<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <div>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <input v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <v-select
                                    v-model="filter.province_id"
                                    :options="provinceOptions"
                                    :reduce="item => item.id"
                                    label="nama_provinsi"
                                    placeholder="Semua Provinsi"
                                    :clearable="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-2" />
                    </div>
                </div>
                <div class="col-md-6" />
            </div>
            <b-card no-body class="col-md-12 p-1">
                <div class="row">
                    <div class="col-md-2 ml-auto">
                        <div class="form-group">
                            <select v-model="perPage" class="form-control">
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row p-2">
                    <div class="col-md-12">
                        <div class="table-scroll-wrapper">
                            <table class="table b-table table-bordered table-fixed mb-0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Provinsi</th>
                                        <th>Kabupaten/Kota</th>
                                        <th>ID BPS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="4" class="text-center">
                                            <b-spinner label="Loading..." variant="primary" />
                                        </td>
                                    </tr>
                                    <template v-if="!isLoading">
                                        <tr v-for="item in result.data" :key="item.id">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.nama_provinsi }}</td>
                                            <td>{{ item.nama_kabkot }}</td>
                                            <td>{{ item.id_bps }}</td>
                                        </tr>
                                    </template>
                                    <tr v-if="!isLoading && result.data.length === 0">
                                        <td colspan="4" class="text-center">
                                            Data is empty.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row mt-1">
                            <div class="col-6 pl-2">
                                <small>Showing {{ result.from || 0 }} to {{ result.to || 0 }} from {{ result.total || 0 }}</small>
                            </div>
                            <div class="col-6 pr-2">
                                <pagination
                                    :data="result"
                                    :limit="4"
                                    align="right"
                                    @pagination-change-page="page => getData(page)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {
        BCard,
        BSpinner,
    } from 'bootstrap-vue'
    import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
    import Vue from 'vue'
    import VuejsDialog from 'vuejs-dialog'
    import vSelect from 'vue-select'

    import 'vuejs-dialog/dist/vuejs-dialog.min.css'

    Vue.use(VuejsDialog)

    export default {
        components: {
            BCard,
            BSpinner,
            vSelect,
        },
        title() {
            return 'Master Data - Kabupaten/Kota'
        },
        watch: {
            filter: {
                handler: _.debounce(function () {
                    this.getData(1)
                }, 300),
                deep: true,
            },
            perPage() {
                this.getData(1)
            },
        },
        setup() {
            return {
                checkPermission,
                successNotification,
                errorNotification,
            }
        },
        computed: {
        },
        data() {
            return {
                currentPage: 1,
                result: {
                    data: [],
                },
                isLoading: false,
                provinceOptions: [],
                filter: {
                    search: '',
                    province_id: '',
                },
                perPage: 30,
            }
        },
        mounted() {
            this.getData()
            this.getProvinces()
        },
        methods: {
            async getProvinces() {
                try {
                    const res = await this.$http.post('/regions/provinces')
                    this.provinceOptions = res.data.data || []
                } catch (err) {
                    console.log('error provinsi: ', err)
                }
            },
            getData(page = 1) {
                this.isLoading = true
                this.currentPage = page

                this.$http.post('/super-admin/master/regions/cities', {
                    search: this.filter.search,
                    province_id: this.filter.province_id,
                    per_page: this.perPage,
                    page: this.currentPage,
                }).then(response => {
                    this.result = response.data.data
                    this.isLoading = false
                }).catch(() => {
                    this.isLoading = false
                })
            },
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    .custom__form--input .custom__input, .vs__dropdown-toggle {
        background: #fff !important;
    }

    .table-scroll-wrapper {
        height: calc(100vh - 400px);
        min-height: 400px;
        overflow-y: auto;
        overflow-x: auto;
    }

    .table-scroll-wrapper table {
        margin-bottom: 0;
    }

    .table-scroll-wrapper thead th {
        position: sticky;
        top: 0;
        z-index: 100;
        background-color: #f3f2f7;
        white-space: nowrap;
        text-align: center;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
    }

    .table th {
        width: 250px;
        white-space: nowrap;
        text-align: center;
        background-color: #f3f2f7;
    }

    .table td {
        vertical-align: middle;
    }
</style>
